/*
 * @Author: maliang
 * @Date: 2019-07-26 10:28:05
 * @LastEditTime: 2019-08-17 16:53:56
 * @LastEditors: Do not edit
 */
import React, { Component } from 'react';
import './index.scss';
import { Modal, Toast } from 'antd-mobile';

import {wxShareAll, isCRGT, trackPV, trackClick, getTokenAndLogin, isProd, getToken, toUserMeal, isH5, toUserCoupon, shareTo, isMP, getRequestData} from '../../utils/util';

import {isActivityGrant, activityGrant} from '../../services/api';

import Rule from './components/rule';
import Award from './components/award';
import ShareMask from './components/shareMask';

window.activityKey = isProd() ? "activity_m_v4_prod" : "activity_m_v4_dev";

export default class Button extends Component {

  constructor(props) {
    super(props);

    this.state = {
      temp: null,
      modal: false,
      isGrant: true,
      isLoading: true,
      showMask: false,
      modalShare: false,
      logo: "def",
    };

    this.wxShareInfo = {}
  }

  componentDidMount() {

    trackPV("20190925_1", 153);

    // logo
    let urlParams = getRequestData() || {};
    this.setState({
      logo: urlParams.vlogo || "def",
    })

    // 进入页面后首先判断是否已经登录
    getToken().then( async res => {
      
      // 如果登录, 判断是否可以领券
      if(res) {
        const isGrant = await isActivityGrant({key: window.activityKey});

        this.setState({
          "isGrant": isGrant.data,
          "isLoading": false,
        });
      } else{
        this.setState({
          "isLoading": false,
        });
      }
    });

    this.wxShareInfo = {
      title: '国庆乘车 免费送水',
      desc: '国庆高铁出行免费送水啦！还有70元大礼包哦>>',
      link: `https://${window.location.host}/FE-H5-USER-COUPON-V4/#/`,
      imgUrl: 'https://static.ccrgt.com/images/5c4ff92c-713c-446e-9ab1-a34a6e8dc02d.jpg',
      imgUrlMP: 'https://static.ccrgt.com/images/ad03dc1b-8fcd-40d6-9b03-23789745c8c8.jpg',
      directCb: true,
    }

    // 如果是APP进入
    if(isCRGT()) {
      window.crgt.ui.setRightButton({
        items: [{
          icon: 'data:image/png;base64,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'
        }],
        onClick: ()=>{
          this.setState({
            "modalShare": true,
          });
        },
      });

    } else {
      // 如果是小程序或者h5进入
      wxShareAll(this.wxShareInfo);
    }
  }

  refreshData = (data) => {
    // h5分享蒙层
    if(data.type === 4) {

      if(data.showMaskStatus === 1) {
        this.setState({
          "showMask": true,
        });
      } else {
        this.setState({
          "showMask": false,
        });
      }
    }

    // 送水给好友
    if(data.type === 1) {
      this.closePopup();
      this.toShare(2)();
    }

    // 去下单
    if(data.type === 2) {
      this.toMeal("20190925_4")();
    }
  }

  // app分享
  appShare = (type) => () => {
    shareTo(type, this.wxShareInfo);
  }

  // 弹窗
  popup = (index, flag) => async () => {

    this.setState({
      "temp": index
    }, () => {
      this.setState({
        modal: true,
      });
    });
  }

  // 关闭弹窗
  closePopup = () => {
    this.setState({
      "modal": false
    });
  }

  // 关闭分享弹窗
  closeShare = () => {
    this.setState({
      "modalShare": false
    });
  }

  // 我要领券
  grant = async () => {

    trackClick("20190925_2", 153);
    
    // 判断是否登录，如果没有登录，那么去登录
    getTokenAndLogin().then( async res => {

      const token = window.localStorage.getItem("_ACCESSTOKEN_");

      if(res || token) {

        // 获取是否已经领券
        const isGrant = await isActivityGrant({key: window.activityKey});
        
        // 如果可以领券
        if(isGrant.data) {

          const grantCoupon = await activityGrant({key: window.activityKey});

          if(grantCoupon.code === 0) {
            this.popup(2, false)();

            this.setState({
              "isGrant": false,
            });
          } else {
            Toast.info(grantCoupon.errmsg);
          }
          return;
        }

        this.setState({
          "isGrant": false,
          "isLoading": false,
        });

      }
    });
  }

  // 去订餐页
  toMeal = (type) => () => {
    trackClick(type, 153);

    setTimeout(()=> {
      toUserMeal();
    }, 100);
  }

  // h5扫码
  h5Track = (type) => () => {
    trackClick(type, 153);
  }

  // 去神券
  toCoupon = () => {
    trackClick("20190925_7", 153);
    toUserCoupon();
  }

  // 分享
  toShare = (type) => () => {
    if(type === 1) {
      trackClick("20190925_5", 153);
    } else {
      trackClick("20190925_6", 153);
    }

    if(isCRGT()) {
      this.setState({
        "modalShare": true,
      });
    } else {
      this.setState({
        "showMask": true,
      });
    }
  }

  render() {

    return(
      <React.Fragment>
        <div className={`page-h5-coupon-v4 ${this.state.logo === "def" ? "def" : ""}`}>

          {/* logo */}
          <div className={`logo ${this.state.logo}`}></div>

          {/* 券 */}
          <div className={`p-coupon coupon ${this.state.isGrant ? "n" : "y"}`}>
            <div className="price">
              <small>¥</small>
              <span>5</span>
            </div>

            <div className="desc">
              <strong>免费饮水券</strong>
              <span>高铁订餐通用</span>
            </div>

            {
              this.state.isLoading
              ?
              <div className="coupon-loading">加载中...</div>
              :
              this.state.isGrant
              ?
              <div className="control">
                <button className="btn fill big" onClick={this.grant}>我要领券</button>
              </div>
              :
              !isH5()
              ?
              <div className="control">
                <button className="btn fill small" onClick={this.toMeal("20190925_3")}>去下单</button>
                <button className="btn def small" onClick={this.toShare(1)}>送水给好友</button>
              </div>
              :
              <div className="qr" onClick={this.h5Track("20190925_9")}>
                <img src="https://static.ccrgt.com/images/4bb50480-8e10-4cf3-a31d-619aff78d112.png" />
                <span>长按扫码至“掌上高铁”小程序下单</span>
              </div>
            }
          </div>

          {/* 领水指南  */}
          <div className="p-step"></div>

          {/* 入口 */}
          <div className="p-enter">
            {
              !isH5()
              ?
              <div className="ismp">
                <a href="javascript:" className="p1" onClick={this.toCoupon}></a>
                <a href="javascript:" className="p2" onClick={this.toMeal("20190925_8")}></a>
              </div>
              :
              <div className="nomp" onClick={this.h5Track("20190925_10")}>
                {
                  this.state.logo === "l3"
                  ?
                  <img src="https://static.ccrgt.com/images/be431f8f-eda0-4a9e-bd5c-0b4c338b8065.png" />
                  :
                  <img src="https://static.ccrgt.com/images/451262b2-e5a7-4643-b157-1552c0ab5355.png" />
                }
              </div>
            }
          </div>

          {/* 活动规则按钮 */}
          <button className="rule-btn" onClick={this.popup(1, false)}></button>

          <ShareMask refresh={this.refreshData} showMask={this.state.showMask} />
        </div>

        <Modal
          visible={this.state.modalShare}
          popup
          className="modal-share"
          animationType="slide-up"
          onClose={this.closeShare}
        >
          <div className="title">
            <span>分享行程</span>
          </div>
          <div className="share">
            
            <button className="share-btn wx" onClick={this.appShare(1)}>
              <span>微信</span>
            </button>
            
            <button className="share-btn pyq" onClick={this.appShare(2)}>
              <span>朋友圈</span>
            </button>
          </div>
          <div className="control">
            <button onClick={this.closeShare}>取消</button>
          </div>
        </Modal>

        <Modal
        visible={this.state.modal}
        transparent
        className="modal-popup"
        >
          <div className="popup">
            <div className="container">

              {/* 弹窗模块 */}
              {
                this.state.temp === 1
                ?
                <Rule refresh={this.refreshData} />
                :
                <Award refresh={this.refreshData} isH5={isH5()} />
              }
            </div>
            
            <button className="closeModal" onClick={this.closePopup}></button>
          </div>
        </Modal>
      </React.Fragment>
     )
  }
}
